import {
  CharacterStatusEffect,
  CharacterStatusEffectDefinition,
} from '@typings/characterStatusEffect/characterStatusEffect.interface';

export function getTimestampMillis(value?: any): number | null {
  if (!value) return null;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return value;
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  return null;
}

export function isCharacterStatusEffectExpired(
  effect: Pick<CharacterStatusEffect, 'expiresAt'>,
  now = Date.now(),
) {
  const expiresAt = getTimestampMillis(effect.expiresAt);
  return expiresAt !== null && expiresAt <= now;
}

export function formatCharacterStatusEffectRemainingTime(
  expiresAtValue?: any,
  now = Date.now(),
) {
  const expiresAt = getTimestampMillis(expiresAtValue);
  if (expiresAt === null) return '수동 해제';

  const totalMinutes = Math.ceil((expiresAt - now) / 60000);
  if (totalMinutes <= 0) return '해제 예정';

  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) return `${days}일 ${hours}시간`;
  if (hours > 0) return `${hours}시간 ${minutes}분`;
  return `${totalMinutes}분`;
}

export function buildCharacterStatusEffectId({
  characterPath,
  characterId,
  effectId,
}: Pick<CharacterStatusEffect, 'characterPath' | 'characterId' | 'effectId'>) {
  return `${characterPath}_${characterId}_${effectId}`.replace(/[\/\s]+/g, '_');
}

export function sortCharacterStatusEffectDefinitions(
  a: CharacterStatusEffectDefinition,
  b: CharacterStatusEffectDefinition,
) {
  return (a.sortOrder || 0) - (b.sortOrder || 0);
}
